import { state } from './moduleContactState';
import { actions } from './moduleContactActions';
import { mutations } from './moduleContactMutations';
import { getters } from './moduleContactGetters';

export const moduleContact = {
    namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters,
}